/**
 * Filters out metadata fields from optimization preferences for analytics tracking
 * @param preferences - The optimization preferences object
 * @returns Object with only optimization preference fields, or undefined if preferences is null/undefined
 */
export const filterOptimizationPreferencesForTracking = (
  preferences: any,
): Record<string, any> | undefined => {
  if (!preferences) return undefined;

  const {
    __typename,
    id,
    createdAt,
    updatedAt,
    organizationId,
    userId,
    ...optimizationPreferences
  } = preferences;
  
  return optimizationPreferences;
};
